export default function(
  state = {
    code: 200
  },
  action
) {
  if (action.type === 'NOT_FOUND_STATUS') {
    return {
      code: 404
    };
  }

  if (action.type === 'ERROR_STATUS') {
    return {
      code: action.status
    };
  }

  if (action.type === 'UNPUBLISHED_STATUS') {
    return {
      code: 403
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/status_reducer.js